import {CommonModule} from '@angular/common';
import { NgModule } from '@angular/core';
import { ListSearchComponent } from './list-search.component';

@NgModule({
  declarations: [
    ListSearchComponent
  ],
    imports: [
        CommonModule
    ],
  exports: [
    ListSearchComponent
  ]
})
export class ListSearchModule { }
